import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
const useTheme = () => {
	let themes = ["light", "dark"];
	let icons = [<Icon icon="ic:round-brightness-4" />, <Icon icon="ic:round-brightness-high" />];
	const [icon, setIcon] = useState(<Icon icon="ic:round-brightness-4" />);
	let [theme, setTheme] = useState("light");
	let changeTheme = () => {
		let index = themes.indexOf(theme);
		if (index === themes.length - 1) {
			setTheme(themes[0]);
			setIcon(icons[0]);
		} else {
			setTheme(themes[index + 1]);
			setIcon(icons[index + 1]);
		}
	};
	useEffect(() => {}, [theme]);
	return [theme, <div onClick={changeTheme}>{icon}</div>];
};

export default useTheme;
